import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import mutator from 'mutator';

export default graphql(
  gql`
    mutation DeleteMember($input: DeleteMemberInput!) {
      deleteMember(input: $input)
    }
  `,
  {
    props: ({ mutate }) => ({
      deleteMember: async (input) => {
        return mutator(() =>
          mutate({
            variables: { input },
          })
        );
      },
    }),
  }
);
